<template>
  <div>

    <!--タイトル-->
    <header id="header">
      <h1 class="logo" v-show="isGeo"><span><img src="static/images/common/logo-geo3.svg" alt="新詳地理探究"></span></h1>
      <h1 class="logo" v-show="isHistory"><span><img src="static/images/common/logo-his2.svg" alt="新詳世界史探究"></span></h1>
      <h1 class="logo" v-show="isCivics"><span><img src="static/images/common/logo-pub.svg" alt="高等学校　公共"></span></h1>
    </header>

    <div class="container">
      <div id="wrapper" class="top">
        <div class="content">
          <nav class="index-nav">

            <ul v-show="isGeo" class="top">
              <!--一問一答（共通）-->
              <li><a href="#" v-on:click.prevent='showQuestion'><img src="static/images/common/menu-question.svg" alt="一問一答"></a></li>
              <!--用語解説（共通）-->
              <li><a href="#" v-on:click.prevent='showWord'><img src="static/images/common/menu-word.svg" alt="用語解説"></a></li>
              <!--動画-->
              <li><a href="#" v-on:click.prevent='showMovie'><img src="static/images/common/menu-video.svg" alt="動画"></a></li>
              <!--WebGIS-->
              <li><a href="#" v-on:click.prevent='showWebGis'><img src="static/images/common/menu-gis.svg" alt="WebGIS"></a></li>
              <!--統計資料-->
              <li><a href="#" v-on:click.prevent='showStat'><img src="static/images/common/menu-statistics.svg" alt="統計資料"></a></li>
              <!--地理院地図で見てみよう-->
              <li><a href="#" v-on:click.prevent='showGeograph'><img src="static/images/common/menu-geographical.svg" alt="地理院地図で見てみよう"></a></li>
              <!--さまざまな時代の地図・地図投影法-->
              <li><a href="#" v-on:click.prevent='showProjection'><img src="static/images/common/menu-projection.svg" alt="さまざまな時代の地図・地図投影法"></a></li>
              <!--学習に役立つリンク集-->
              <li><a href="#" v-on:click.prevent='showLink'><img src="static/images/common/menu-links-learning.svg" alt="学習に役立つリンク集"></a></li>
            </ul>

            <ul v-show="isHistory" class="top">
              <!--一問一答（共通）-->
              <li><a href="#" v-on:click.prevent='showQuestion'><img src="static/images/common/menu-question.svg" alt="一問一答"></a></li>
              <!--演習問題-->
              <li><a href="#" v-on:click.prevent='showPractice'><img src="static/images/common/menu-practice.svg" alt="演習問題"></a></li>
              <!--重要用語-->
              <li><a href="#" v-on:click.prevent='showWord'><img src="static/images/common/menu-word2.svg" alt="重要用語"></a></li>
              <!--動画-->
              <li><a href="#" v-on:click.prevent='showMovie'><img src="static/images/common/menu-video.svg" alt="動画"></a></li>
              <!--地図-->
              <li><a href="#" v-on:click.prevent='showMap'><img src="static/images/common/menu-map.svg" alt="地図"></a></li>
              <!--外部団体へのリンク-->
              <li><a href="#" v-on:click.prevent='showLink'><img src="static/images/common/menu-links.svg" alt="外部リンク"></a></li>
            </ul>

            <ul v-show="isCivics" class="top">
              <!--一問一答（共通）-->
              <li><a href="#" v-on:click.prevent='showQuestion'><img src="static/images/common/menu-question.svg" alt="一問一答"></a></li>
              <!--用語解説（共通）-->
              <li><a href="#" v-on:click.prevent='showWord'><img src="static/images/common/menu-word.svg" alt="用語解説"></a></li>
              <!--判例解説-->
              <li><a href="#" v-on:click.prevent='showSample'><img src="static/images/common/menu-case.svg" alt="判例解説"></a></li>
              <!--動く図版-->
              <li><a href="#" v-on:click.prevent='showImage'><img src="static/images/common/menu-illustration.svg" alt="動く図版"></a></li>
              <!--動画-->
              <li><a href="#" v-on:click.prevent='showMovie'><img src="static/images/common/menu-video.svg" alt="動画"></a></li>
              <!--年表-->
              <li><a href="#" v-on:click.prevent='showTimeline'><img src="static/images/common/menu-chronology.svg" alt="年表"></a></li>
              <!--法令集-->
              <li><a href="#" v-on:click.prevent='showLaw'><img src="static/images/common/menu-law.svg" alt="法令集"></a></li>
              <!--外部団体へのリンク-->
              <li><a href="#" v-on:click.prevent='showLink'><img src="static/images/common/menu-links.svg" alt="外部リンク"></a></li>
          </ul>

          </nav>
        </div>
      </div>

    </div>

    <!--
    <button class='btn btn-lg btn-primary btn-block' data-remodal-target="modal33">vsvs</button>
    <div id="detailPopup" data-remodal-id="modal33" class="remodal modal-result-box" data-remodal-options="hashTracking:false">
      <div class="modal-content">
        <div class="btn-close-box">
          <button data-remodal-action="close" type="button" class="btn btn-close"><img src="static/images/common/btn/btn-close.svg" alt="閉じる"></button>
        </div>
        <div class="text-box">
          <p>地理的位置を手がかりに位置に関する情報をもったデータ（空間データ）を総合的に管理・加工し，視覚的に表示し，高度な分析や迅速な判断を可能にする技術のことを何というか。</p>
          <h4 class="ttl">パークアンドライド</h4>
        </div>
      </div>
    </div>
    -->

    <footer id="footer">
      <div class="term-box">
        <div class="box-l">
          <a href="#" rel="noopener" target="_blank" class="btn-term" v-on:click.prevent='showRule'><img src="static/images/common/btn/btn-term.svg" alt="利用規約"></a>
        </div>
        <div class="box-r">
          <p class="logo-teikokushoin"><a href="https://www.teikokushoin.co.jp/" rel="noopener" target="_blank"><img src="static/images/common/logo-teikokushoin.svg" alt="帝国書院"></a></p>
        </div>
      </div>
    </footer>

  </div>
</template>

<script>
import Header from '@/components/modules/Header'
import router from '@/router'
import cmd from '@/common/Command'
import { mapActions, mapGetters } from 'vuex'

export default {
  data: function () {
    return {
      title: router.currentRoute.name,
    }
  },
  mounted: function () {
    $("body").removeClass();
    $("body").addClass("page-index");
    cmd.adjustStyle()

  },
  methods: {
    ...mapActions('MenuModule', [
      'showWord',
      'showQuestion',
      'showMovie',
      'showWebGis',
      'showStat',
      'showRule',
      'showMap',
      'showPractice',
      'showTimeline',
      'showLink',
      'showLaw',
      'showImage',
      'showSample',
      'showGeograph',
      'showProjection',
    ]),
    linkAction (e) {
      //$('[data-remodal-id=modal33]').remodal();
    }

  },
  computed: {
    ...mapGetters('MenuModule', [
      'isGeo',
      'isHistory',
      'isCivics',
    ])
  },
  components: {
    Header
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Menu.vue